import { ExportRow } from '@portal/shared/types/export.types';
import { DeviceType } from 'src/app/pages/equipment/devices/components/devices.models';
import { devicesWithoutSerialNumber } from 'src/app/pages/equipment/devices/constants/devices.constants';
import { AlarmsRows } from '../services/alarm-data.types';

export const mapAlarmToExport = (alarm: AlarmsRows): ExportRow => ({
  dateTime: { title: 'Alarm Date/Time', value: alarm.dateTime },
  severity: { title: 'Alarm Severity', value: alarm.severity },
  groupName: { title: 'Alarm Group', value: alarm.groupName },
  name: { title: 'Alarm Name', value: alarm.name },
  deviceTypeName: { title: 'Device Type', value: alarm.deviceTypeName },
  commodity: { title: 'Commodity', value: alarm.commodity },
  commDeviceId: {
    title: 'CommDeviceID',
    value: alarm.commDeviceId ?? alarm.parentCommDeviceId ?? ''
  },
  serialNumber: {
    title: 'SerialNumber',
    value: devicesWithoutSerialNumber.includes(alarm.deviceType as DeviceType)
      ? ''
      : (alarm.serialNumber ?? 'Unknown Serial Number')
  },
  modelName: { title: 'ModelName', value: alarm.modelName },
  location: [
    { title: 'Latitude', value: alarm.geoMetaData?.latitude ?? '' },
    { title: 'Longitude', value: alarm.geoMetaData?.longitude ?? '' },
    { title: 'Comment', value: alarm.geoMetaData?.comments ?? '' }
  ]
});
